module.exports = "/_next/static/images/edb2613708c9f05f57e2cd1f0e98eece-perks-lg-2x.jpg";